import { AreaType, FloorType, BuildingType } from "api/schema";
import { TimeSlot } from "shared/utils/date";
import { State, initialState, Action, ActionType } from "./definitions";

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionType.RESET: {
      return {
        ...initialState,
      };
    }
    case ActionType.SELECT_DATE: {
      return {
        ...state,
        selectedDate: action.payload as Date,
      };
    }
    case ActionType.SELECT_BUILDING: {
      return {
        ...state,
        selectedBuilding: action.payload as BuildingType,
        floors: [],
        selectedFloor: undefined,
        meetingRooms: [],
        selectedMeetingRoom: undefined,
      };
    }
    case ActionType.SET_FLOORS: {
      const floors = action.payload as FloorType[];
      const selectedFloor = floors.find(
        (f) => f.id === state.selectedFloor?.id,
      );
      return {
        ...state,
        floors,
        selectedFloor,
        meetingRooms: [],
        selectedMeetingRoom: undefined,
      };
    }
    case ActionType.SELECT_FLOOR: {
      return {
        ...state,
        selectedFloor: action.payload as FloorType,
        meetingRooms: [],
        selectedMeetingRoom: undefined,
      };
    }
    case ActionType.SET_MEETING_ROOMS: {
      const meetingRooms = action.payload as AreaType[];
      const selectedMeetingRoom = meetingRooms.find(
        (r) => r.id === state.selectedMeetingRoom?.id,
      );
      return {
        ...state,
        meetingRooms,
        selectedMeetingRoom,
      };
    }
    case ActionType.SELECT_MEETING_ROOM: {
      return {
        ...state,
        selectedMeetingRoom: action.payload as AreaType,
      };
    }
    case ActionType.SET_UNAVAILABLE_SLOTS: {
      return {
        ...state,
        unavailableSlots: action.payload as number[],
      };
    }
    case ActionType.SET_IS_FAV_ROOM: {
      return {
        ...state,
        isFavRoom: action.payload as boolean,
      };
    }
    case ActionType.SET_HOURS_RANGE: {
      const [start, end] = action.payload as TimeSlot;
      return {
        ...state,
        hoursStart: start,
        hoursEnd: end,
      };
    }
    default:
      throw new Error("Unknown action");
  }
}
